(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  ready(() => {
    const header = document.querySelector('[data-header]');
    if (header) {
      const menuButton = header.querySelector('[data-menu-toggle]');
      const nav = header.querySelector('[data-primary-nav]');
      const searchButton = header.querySelector('[data-search-toggle]');
      const searchDrawer = header.querySelector('[data-search-drawer]');
      const searchInput = searchDrawer?.querySelector('input[type="search"]');
      const closeSearch = (restoreFocus = false) => {
        const wasOpen = searchDrawer && !searchDrawer.hasAttribute('hidden');
        if (!searchDrawer) return;
        searchDrawer.setAttribute('hidden', '');
        searchButton?.setAttribute('aria-expanded', 'false');
        if (wasOpen && restoreFocus) searchButton?.focus();
      };
      const closeMenu = (restoreFocus = false) => {
        const wasOpen = nav?.classList.contains('is-open');
        nav?.classList.remove('is-open');
        menuButton?.setAttribute('aria-expanded', 'false');
        menuButton?.setAttribute('aria-label', 'Open menu');
        document.body.classList.remove('menu-open');
        if (wasOpen && restoreFocus) menuButton?.focus();
      };
      menuButton?.addEventListener('click', () => {
        const open = !nav?.classList.contains('is-open');
        if (open) closeSearch();
        nav?.classList.toggle('is-open', open);
        menuButton.setAttribute('aria-expanded', String(open));
        menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        document.body.classList.toggle('menu-open', open);
      });
      searchButton?.addEventListener('click', () => {
        const open = searchDrawer.hasAttribute('hidden');
        if (open) closeMenu();
        searchDrawer.toggleAttribute('hidden', !open);
        searchButton.setAttribute('aria-expanded', String(open));
        if (open) window.setTimeout(() => searchInput?.focus(), 20);
      });
      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          closeMenu();
          closeSearch();
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu(true);
          closeSearch(true);
        }
      });
      window.addEventListener('scroll', () => header.classList.toggle('is-scrolled', window.scrollY > 8), { passive: true });
    }

    document.querySelectorAll('[data-product-form]').forEach((root) => {
      const select = root.querySelector('select[name="id"]');
      const json = root.querySelector('[data-variants-json]');
      if (!select || !json) return;
      let variants = [];
      try { variants = JSON.parse(json.textContent); } catch (_) { return; }
      const optionGroups = [...root.querySelectorAll('[data-option-group]')];
      const addButton = root.querySelector('[data-add-to-cart]');
      const price = root.closest('[data-product-section]')?.querySelector('[data-product-price]');
      const status = root.querySelector('[data-product-status]');
      const selected = optionGroups.map((group) => group.querySelector('[aria-pressed="true"]')?.dataset.value || '');

      const update = (revealMedia = false) => {
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        optionGroups.forEach((group, groupIndex) => {
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const proposed = [...selected];
            proposed[groupIndex] = button.dataset.value;
            const available = variants.some((item) => item.available && item.options.every((value, index) => !proposed[index] || value === proposed[index]));
            button.disabled = !available;
          });
        });
        if (!variant) {
          if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
          if (status) status.textContent = 'This option combination is unavailable.';
          return;
        }
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        if (price && variant.formatted_price) price.textContent = variant.formatted_price;
        if (status) status.textContent = variant.available ? 'Variant selected.' : 'This variant is sold out.';
        if (revealMedia && variant.featured_media_id) {
          const target = `Media-${variant.featured_media_id}`;
          const thumb = document.querySelector(`[data-media-thumb][data-media-target="${target}"]`);
          if (thumb) thumb.click();
          else document.querySelectorAll('[data-media-panel]').forEach((panel) => panel.classList.toggle('is-hidden', panel.id !== target));
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.addEventListener('click', () => {
            selected[groupIndex] = button.dataset.value;
            group.querySelectorAll('[data-option-value]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            group.querySelector('[data-option-selected]')?.replaceChildren(document.createTextNode(button.dataset.value));
            update(true);
          });
        });
      });
      update();
    });

    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const thumbs = [...gallery.querySelectorAll('[data-media-thumb]')];
      const panels = [...gallery.querySelectorAll('[data-media-panel]')];
      const show = (target) => {
        thumbs.forEach((thumb) => {
          const active = thumb.dataset.mediaTarget === target;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
        panels.forEach((panel) => panel.classList.toggle('is-hidden', panel.id !== target));
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.mediaTarget)));
    });

    document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      const buttons = [...tabs.querySelectorAll('[data-product-tab]')];
      const panels = [...tabs.querySelectorAll('[data-product-panel]')];
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => panel.toggleAttribute('hidden', panel.dataset.productPanel !== button.dataset.productTab));
      }));
    });

    document.querySelectorAll('[data-apply-discount]').forEach((button) => {
      button.addEventListener('click', () => {
        const wrap = button.closest('[data-discount-form]');
        const input = wrap?.querySelector('input');
        const status = wrap?.querySelector('[data-promo-status]');
        const code = input?.value.trim().toUpperCase();
        if (!code) { if (status) status.textContent = 'Enter a promo code.'; input?.focus(); return; }
        if (status) status.textContent = 'Applying promo code…';
        window.location.href = `/discount/${encodeURIComponent(code)}?redirect=%2Fcart`;
      });
    });
  });
})();